import { render, staticRenderFns } from "./PartnersArchive.vue?vue&type=template&id=2a9d45b0"
import script from "./PartnersArchive.vue?vue&type=script&lang=js"
export * from "./PartnersArchive.vue?vue&type=script&lang=js"
import style0 from "./PartnersArchive.vue?vue&type=style&index=0&id=2a9d45b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports